import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { FIXED_INDENTS } from 'vars/index'
import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1Headline3SecondaryProps extends ITextBoxProps {}

export const TextBoxMaxLine1Headline3Secondary = ({
  title = '',
  color = Colors.TEXT_ICON_SECONDARY,
  font = TextBoxTypes.Headline3,
  alignment = TextAligning.Left,
  maxLines = 1,
  verticalPaddings = FIXED_INDENTS.INDENT_30,
  ...rest
}: ITextBoxMaxLine1Headline3SecondaryProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    verticalPaddings={verticalPaddings}
    {...rest}
  />
)
